import request from '../utils/request';
import { clientbookApi } from '../core/clientbook-api';

// available params: limit, page, search, filters, sort_order, sort_direction
export const getProducts = ({ params = {} }) => {
  return request({
    url: '/products',
    method: 'GET',
    params,
  });
};

export const getProductsElasticSearch = ({ params = {} }) => {
  return request({
    url: '/products/elasticSearch',
    method: 'GET',
    params,
  });
};

// available params: page, pageSize, search
export const getProductsBrands = ({ params = {} }) => {
  return request({
    url: '/products/brands',
    method: 'GET',
    params,
  });
};

// available params: archived, available
// Note: This now uses the unified v1 search API (clientbook-api) which returns all categories at once (no pagination)
export const getProductsCategories = async ({ params = {} }) => {
  // Convert GET params to POST body with defaults
  const body = {
    archived: params.archived ?? false,
    available: params.available ?? true,
  };

  try {
    // Use clientbookApi which properly handles auth tokens during impersonation
    // (localStorage.getItem('jwtToken') is empty during console login)
    const response = await clientbookApi.post({
      url: '/searches/products/categories',
      data: body,
    });

    // Adapt response to maintain backward compatibility with existing consumers
    // New API returns: { total: number, data: [{ name: string, count: number }] }
    // Old API returned: { results: string[], page, pageSize, pages, total }
    return {
      data: {
        results: response.data.map(item => item.name),
        page: 1,
        pageSize: response.total,
        pages: 1,
        total: response.total,
      },
    };
  } catch (error) {
    // Treat 404 as "no categories found" instead of an error
    if (error.response && error.response.status === 404) {
      return {
        data: {
          results: [],
          page: 1,
          pageSize: 0,
          pages: 0,
          total: 0,
        },
      };
    }
    // Re-throw other errors
    throw error;
  }
};

export const getProductById = id => {
  return request({
    url: `/products/${id}`,
    method: 'GET',
  });
};

export const deleteProductById = id => {
  return request({
    url: `/products/${id}`,
    method: 'DELETE',
  });
};

export const createProduct = data => {
  return request({
    url: '/products',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

export const updateProduct = (id, data) => {
  return request({
    url: `/products/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};
